import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const AnonymousTransaction = ApplicationRecord.extend({
  attrs: {
    purchase_id: attr(),
    external_payload: attr(),
    card_token: attr(),
    threeds_redirect_url: attr(),
  },
  static: {
    endpoint: '/anonymous_transactions',
    jsonapiType: 'payments-anonymous_transactions',
  },
});

export default AnonymousTransaction;
